import { UapiHarvestStatsByDateBucket, UapiHarvestStatsByRangeBucket, UapiHarvestStatsBySeedProductBucket } from '../../../../../../graphql/sdk';
import { BySeedProductDimension, ByRangeDimension, ByDateDimension } from '../../../../../../types/FieldRegionReport';
import { adaptMeasurement, adaptMetricStats } from './statsAdapter';
import { MOISTURE_PERCENT_DEFAULT_UNIT, NOMINAL_WEIGHT_DEFAULT_UNIT } from './constants';

export const mapBySeedProductDimension = (item: UapiHarvestStatsBySeedProductBucket): BySeedProductDimension => ({
   seedProduct: {
    id: item?.seedProduct?.id ?? '',
    name: item?.seedProduct?.name ?? undefined,
  },
  stats: adaptMetricStats(item.stats),
  cropNominalMoisture: item.cropNominalMoisture ?
    adaptMeasurement(item.cropNominalMoisture, MOISTURE_PERCENT_DEFAULT_UNIT)
    : null,
  cropNominalWeight: item.cropNominalWeight ?
    adaptMeasurement(item.cropNominalWeight, NOMINAL_WEIGHT_DEFAULT_UNIT)
    : null
});

export const mapByRangeDimension = (item: UapiHarvestStatsByRangeBucket): ByRangeDimension => ({
  min: item?.min ?? null,
  max: item?.max ?? null,
  units: item?.units ?? undefined,
  stats: adaptMetricStats(item?.stats),
});

export const mapByDateDimension = (item: UapiHarvestStatsByDateBucket): ByDateDimension => ({
  date: item?.date ?? null,
  stats: adaptMetricStats(item?.stats),
});

export const adaptBySeedProductDimension = (
  items: Array<UapiHarvestStatsBySeedProductBucket>
): BySeedProductDimension[] => items.map(item => mapBySeedProductDimension(item));

export const adaptByRangeDimension = (
  items: Array<UapiHarvestStatsByRangeBucket>
): ByRangeDimension[] => items.map(item => mapByRangeDimension(item));

export const adaptByDateDimension = (
  items: Array<UapiHarvestStatsByDateBucket>
): ByDateDimension[] => items.map(item => mapByDateDimension(item))
